import { render, staticRenderFns } from "./FooterXianlin.vue?vue&type=template&id=3551385e&"
import script from "./FooterXianlin.vue?vue&type=script&lang=js&"
export * from "./FooterXianlin.vue?vue&type=script&lang=js&"
import style0 from "./FooterXianlin.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports